import { render } from "./Directorio.vue?vue&type=template&id=37b0b450&scoped=true"
import script from "./Directorio.vue?vue&type=script&lang=ts"
export * from "./Directorio.vue?vue&type=script&lang=ts"

import "./Directorio.vue?vue&type=style&index=0&id=37b0b450&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-37b0b450"

export default script